import React, { useContext, useEffect, useState } from "react";
import { Modal, Button } from "rsuite";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import {
  EPSelectPicker,
  EPDatePicker,
  EPInput,
  EPAutoComplete,
} from "../../../../common/controls";
import {
  axiosPatch,
  axiosGet,
  axiosPost,
  axiosGetParams,
} from "../../../../common/utils/helper";
import {
  updateDelete,
  getCancelAndRescheduleOpt,
  NewRescheduledInterview,
  getCandidateDetailById,
  getStatusByDescription,
  getCancelReasons,
  getInterviewerDetails,
  getInterviewTypeAndRounds,
  getRoundCount,
} from "../../../../common/utils/api";
import "./RescheduleInterviewModal.scss";
import { EPConfirmationDialog } from "../../../../common/controls/confirmationDialog";
import { useParams } from "react-router-dom";
import { CommonConstants } from "../../../../common/utils/CommonConstants";
import { UserContext } from "../../../layout/layout";
import Loader from "../../../Loader/loader";

interface Interview {
  EmployeeId: number | null;
  FirstName: string | null;
  LastName: string | null;
}
interface Props {
  open: boolean;
  setOpen: Function;
  reSchedule?: boolean;
  setDataList?: React.Dispatch<React.SetStateAction<any[]>>;
  singleData?: any;
  refresher?: boolean;
  setRefresher?: any;
  RequirementId?: any;
  setLoading?: any;
  ApiType?: string;
  action?: string;
}
const RequestObject = {
  ScheduleType: null,
  RoundType: null,
  ScheduleDateTime: null,
  PrimaryInterviewer: null,
  RoundCount: 1,
};
const InterviewObject = [
  {
    EmployeeId: parseInt(""),
    FirstName: "",
    LastName: "",
  },
];

interface CandidateData {
  Email: string;
  ExperienceMonth: number;
  ExperienceYear: number;
  FirstName: string;
  Gender: string;
  LastName: string;
  MobileNumber: string; // Need Number Type?
}
const RescheduleInterviewModal = (props: Props) => {
  const {
    open,
    setOpen,
    reSchedule,
    singleData,
    RequirementId,
    action,
    refresher,
    setRefresher,
  } = props;
  const [isValidate, setIsValidate] = useState(false);
  const [onCloseConfirmation, setOnCloseConfirmation] =
    useState<boolean>(false);
  const [CandidateDetails, setCandidateDetails] = useState<CandidateData>();
  const [InterviewerData, setInterviewerData] =
    useState<Interview[]>(InterviewObject);
  const [cancelStatus, setCancelStatus] = useState<any>([]);
  const [cancelReason, setcancelReason] = useState<any>([]);
  const { candidateId } = useParams();
  const [filterData, setFilterData] = useState<any>({
    // ScheduleCancelReason: CommonConstants.REASON_CANDIDATE_NOT_AVAILABLE,
    ScheduleType: singleData.ScheduleType,
    RoundType: singleData.RoundId,
    RoundCount: singleData.RoundCount,
    PrimaryInterviewer: singleData.PrimaryInterviewerId,
    SecondaryInterviewer: singleData.SecondaryInterviewerId,
  });
  const [ScheduleType, setScheduleType] = useState([]);
  const [RoundType, setRoundType] = useState([]);
  const [isDisabled, setDisableRoundType] = useState<boolean>(false);
  const [Loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    let Round: number = 1;
    if (singleData.Round === "Technical") {
      Round = 1;
    } else if (singleData.Round === "Management") {
      Round = 2;
    } else if (singleData.Round === "HR") {
      Round = 3;
    } else if (singleData.Round === CommonConstants.VIRTUAL_ROUNDNAME) {
      Round = 4;
    }
    Promise.all([
      getStatusList(`${getStatusByDescription}`),
      getInterviewTypeAndRound(`${getInterviewTypeAndRounds}`),
      getRescheduleReasons(
        `${getCancelReasons}/${CommonConstants.GROUP_DETAIL_ID_OF_MASTER_54}`
      ),
      getCandidateData(`${getCandidateDetailById}/${candidateId}`),

      getInterviewerData(
        `${getInterviewerDetails}?RequirementId=${RequirementId}&Round=${Round}`
      ),
    ]).then(() => {
      setLoading(false);
    });
  }, []);

  async function getInterviewTypeAndRound(reqUrl: string) {
    const response = (await axiosGetParams(reqUrl)) as AxiosResponse;
    if (
      response &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      response.data.data.ScheduleTypeData.length > 0 &&
        setScheduleType(response.data.data.ScheduleTypeData);
      response.data.data.RoundData.length > 0 &&
        setRoundType(response.data.data.RoundData);
    }
  }

  async function getInterviewerData(reqUrl: string) {
    const response = (await axiosGet(reqUrl)) as AxiosResponse;
    if (
      response &&
      response?.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      response.data?.data?.length > 0
        ? setInterviewerData(response?.data?.data)
        : toast.error("No interview panel has been assigned for this round", {
            position: toast.POSITION.TOP_CENTER,
          });
    }
  }

  async function getCandidateData(reqUrl: string) {
    const response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    if (
      response &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      setCandidateDetails(response.data.data);
    }
  }

  async function getStatusList(reqUrl: string) {
    const response = (await axiosGetParams(
      reqUrl + "?name=Interview Cancelled"
    )) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
      setCancelStatus(response.data.data);
      if (reSchedule) {
        const rescheduleItem = response.data.data.find((item: any) => {
          return item.StatusName == "Reschedule interview";
        });
        if (rescheduleItem) {
          const optionID = rescheduleItem.StatusId;
          setFilterData((prevFilterData: any) => ({
            ...prevFilterData,
            ScheduleStatus: optionID,
          }));
        }
      } else {
        const rescheduleItem = response.data.data.find((item: any) => {
          return item.StatusName == "Interview Cancelled";
        });
        if (rescheduleItem) {
          const optionID = rescheduleItem.StatusId;
          setFilterData((prevFilterData: any) => ({
            ...prevFilterData,
            ScheduleStatus: optionID,
          }));
        }
      }
    } else {
      console.log(response, "error");
    }
  }

  async function getRescheduleReasons(reqUrl: string) {
    const response = (await axiosGetParams(
      reqUrl + "?name=Interview Cancelled"
    )) as AxiosResponse;
    setcancelReason(response.data.data.data);
  }

  function CrossButton() {
    setOnCloseConfirmation(true);
  }
  function CloseModal() {
    setOpen(false);
  }
  const handleSubmit = async () => {
    setIsValidate(true);
    if (
      filterData?.ScheduleStatus === CommonConstants.STATUS_RESCHEDULE_INTERVIEW
    ) {
      if (
        !filterData.ScheduleDateTime ||
        !filterData?.PrimaryInterviewer ||
        !filterData?.ScheduleCancelReason ||
        !filterData.ScheduleType ||
        !filterData.RoundType ||
        !filterData.RoundCount
      ) {
        setIsValidate(true);
        toast.error("Field cannot be empty.", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      } else {
        RescheduleInterview(
          `${NewRescheduledInterview}/${singleData.ScheduleId}`,
          {
            StatusId: filterData?.ScheduleStatus,
            CancelReasonId: filterData?.ScheduleCancelReason,
            CancelRemarks: filterData?.RemarkData,
            ScheduleDateTime: filterData?.ScheduleDateTime,
            PrimaryInterviewer: filterData?.PrimaryInterviewer,
            SecondaryInterviewer: filterData?.SecondaryInterviewer,
            CandidateDetails: CandidateDetails,
            ScheduleType: filterData.ScheduleType,
            RoundId: filterData.RoundType,
            RoundCount: filterData.RoundCount,
          }
        );
      }
    } else {
      if (!filterData?.ScheduleCancelReason || !filterData?.ScheduleStatus) {
        setIsValidate(true);
        toast.error("Field cannot be empty.", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }
      patchUpdateRequest(`${updateDelete}/${singleData.ScheduleId}`, {
        StatusId: filterData?.ScheduleStatus,
        CancelReasonId: filterData?.ScheduleCancelReason,
        CancelRemarks: filterData?.RemarkData,
      });
    }
  };

  async function RescheduleInterview(reqUrl: string, reqBody: any) {
    setLoading(true);
    try {
      const response = (await axiosPost(reqUrl, reqBody)) as AxiosResponse;
      if (
        response &&
        response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
      ) {
        setLoading(false);
        toast.success("Interview Rescheduled Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        refresher ? setRefresher(false) : setRefresher(true);
        CloseModal();
      } else {
        console.log("error", response);
      }
    } catch (error: any) {
      setLoading(false);
      if (
        error.response.status ===
        CommonConstants.API_RESPONSE_FORBIDDEN_IN_REQUEST
      ) {
        toast.error(`${error?.response?.data?.message}`, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  }

  async function patchUpdateRequest(reqUrl: string, reqBody: any) {
    setLoading(true);
    const response = (await axiosPatch(reqUrl, reqBody)) as AxiosResponse;
    if (
      response &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      setLoading(false);
      refresher ? setRefresher(false) : setRefresher(true);
      toast.success("Interview Cancelled Successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      CloseModal();
    }
  }

  const handleOnChange = (value: string | number | Date, name: string) => {
    setFilterData((data: any) => {
      const botInterviewSchedule: any = ScheduleType.find(
        (item: any) =>
          item.ScheduleType === CommonConstants.VIRTUAL_SCHEDULETYPE
      );
      const botRound: any = RoundType.find(
        (item: any) => item.RoundName === CommonConstants.VIRTUAL_ROUNDNAME
      );
      let newData = { ...data };

      if (botInterviewSchedule && botRound) {
        const scheduleTypeId = botInterviewSchedule.ScheduleTypeId;
        const botRoundId = botRound.RoundId;

        // Only if name is "ScheduleType" and the value matches
        if (name === "ScheduleType" && scheduleTypeId == value) {
          // setBotRound(true);
          setDisableRoundType(true);
          newData = {
            ...newData,
            ScheduleType: scheduleTypeId,
            RoundType: botRoundId,
          };
        } else if (
          name == "ScheduleType" &&
          (value == null || scheduleTypeId != value)
        ) {
          // setBotRound(false);
          setDisableRoundType(false);
          newData = {
            ...newData,
            ScheduleType: null,
            RoundType: null,
            PrimaryInterviewer: null,
          };
        } else if (name == "RoundType" && value == botRoundId) {
          // setBotRound(false);
          setDisableRoundType(false);
          newData = {
            ...newData,
            ScheduleType: null,
            RoundType: null,
            PrimaryInterviewer: null,
          };
        }
      }
      if (name == "RoundType" && value !== data[name]) {
        newData = {
          ...newData,
          PrimaryInterviewer: null,
          SecondaryInterviewer: null,
        };
      }
      return {
        ...newData,
        [name]: value !== undefined ? value : data[name],
      };
      // return {
      //   ...data,
      //   [name]: value,
      // };
    });
  };
  async function getRoundNumber(reqUrl: string) {
    const response = (await axiosGet(reqUrl)) as AxiosResponse;
    if (
      response &&
      response.data.data &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      setFilterData((data: any) => {
        return {
          ...data,
          ["RoundCount"]:
            singleData.RoundId === filterData.RoundType
              ? response.data.data
              : response.data.data + 1,
        };
      });
    } else if (response && !response.data.data) {
      setFilterData((data: any) => {
        return {
          ...data,
          ["RoundCount"]: 1,
        };
      });
    }
  }
  useEffect(() => {
    filterData.RoundType &&
      getInterviewerData(
        `${getInterviewerDetails}?RequirementId=${RequirementId}&Round=${filterData.RoundType}`
      );
    filterData.RoundType &&
      getRoundNumber(
        `${getRoundCount}?CandidateId=${candidateId}&RoundId=${filterData.RoundType}`
      );
  }, [filterData.RoundType]);
  return (
    <>
      <Modal
        open={open}
        onClose={CrossButton}
        className="modal-sm"
        backdrop="static"
        keyboard={false}
      >
        {Loading ? (
          <Loader />
        ) : (
          <>
            <Modal.Header closeButton={true}>
              <Modal.Title className="h5-title mt-30">
                Cancel / Reschedule Interview
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col xs lg="12" className="recruiter-label">
                  Status for cancel / Reschedule <span className="req">*</span>
                </Col>

                <Col xs lg="12" className="recruiter-label">
                  <EPSelectPicker
                    isValidate={isValidate}
                    data={cancelStatus}
                    label="ScheduleStatus"
                    onChange={(val: number) =>
                      handleOnChange(val, "ScheduleStatus")
                    }
                    value={filterData?.ScheduleStatus}
                  />
                </Col>

                <Col xs lg="12" className="recruiter-label">
                  Reason for cancel / Reschedule <span className="req">*</span>
                </Col>

                <Col xs lg="12" className="recruiter-label">
                  <EPSelectPicker
                    isValidate={isValidate}
                    data={cancelReason}
                    label="ScheduleCancelReason"
                    onChange={(val: number) =>
                      handleOnChange(val, "ScheduleCancelReason")
                    }
                    value={filterData?.ScheduleCancelReason}
                  />
                </Col>
              </Row>
              {filterData.ScheduleStatus ===
                CommonConstants.STATUS_RESCHEDULE_INTERVIEW && (
                <>
                  <Row>
                    <Col xs lg="12" className="recruiter-label">
                      <Col xs lg="12" className="recruiter-label">
                        Type <span className="req">*</span>
                      </Col>

                      <EPSelectPicker
                        isValidate={isValidate}
                        label="Schedule type"
                        data={ScheduleType}
                        value={filterData.ScheduleType}
                        onChange={(val: number) =>
                          handleOnChange(val, "ScheduleType")
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs lg="12" className="recruiter-label">
                      <Col xs lg="12" className="recruiter-label">
                        Round <span className="req">*</span>
                      </Col>

                      <EPSelectPicker
                        isValidate={isValidate}
                        label="Round type"
                        disabled={isDisabled}
                        data={RoundType}
                        value={filterData.RoundType}
                        onChange={(val: number) =>
                          handleOnChange(val, "RoundType")
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs lg="12" className="recruiter-label">
                      <Col xs lg="12" className="recruiter-label">
                        Round number
                      </Col>

                      <EPInput
                        disabled={true}
                        value={`${filterData.RoundCount}`}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs lg="12" className="recruiter-label">
                      <Col xs lg="12" className="recruiter-label">
                        Primary interviewer <span className="req">*</span>
                      </Col>
                      <EPSelectPicker
                        data={InterviewerData}
                        isValidate={isValidate}
                        label={"PrimaryInterviewer"}
                        value={filterData?.PrimaryInterviewer}
                        onChange={(val: number) =>
                          handleOnChange(val, "PrimaryInterviewer")
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs lg="12" className="recruiter-label">
                      <Col xs lg="12" className="recruiter-label">
                        Secondary interviewer
                      </Col>
                      <EPSelectPicker
                        data={InterviewerData}
                        label={"SecondaryInterviewer"}
                        value={filterData?.SecondaryInterviewer}
                        onChange={(val: number) =>
                          handleOnChange(val, "SecondaryInterviewer")
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs lg="12" className="recruiter-label">
                      <Col xs lg="12" className="recruiter-label">
                        Date Time <span className="req">*</span>
                      </Col>
                      <EPDatePicker
                        disabled={false}
                        isValidate={isValidate}
                        Time={true}
                        value={filterData?.ScheduleDateTime}
                        onChange={(date: Date) =>
                          handleOnChange(date, "ScheduleDateTime")
                        }
                      />
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <Col xs lg="12" className="recruiter-label">
                  Remarks
                </Col>
                <Col xs lg="12" className="recruiter-label">
                  <EPInput
                    textType="textarea"
                    rows={3}
                    maxlength={500}
                    onChange={(val: string) =>
                      handleOnChange(val, "RemarkData")
                    }
                    value={filterData?.RemarkData}
                    // isValidate={isValidate}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="pt-3">
              <Row>
                <Col>
                  <Button
                    type="button"
                    onClick={() => handleSubmit()}
                    className="outline-primary float-start mb-3 px-3"
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Modal.Footer>
          </>
        )}
      </Modal>
      {onCloseConfirmation && (
        <EPConfirmationDialog
          open={onCloseConfirmation}
          setOpen={setOnCloseConfirmation}
          confirmDialogTitle={"Confirm"}
          confirmDialogMessage={
            "Are you sure you want to close, without saving the data?"
          }
          confirmButtonText={"Yes"}
          cancelButtonText={"No"}
          onConfirm={CloseModal}
        />
      )}
    </>
  );
};

export default RescheduleInterviewModal;
function setRefresher(arg0: boolean) {
  throw new Error("Function not implemented.");
}
